import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import { FieldState } from "@homebound/form-state";
import { useEffect } from "react";
import { ChangeEventType } from "src/generated/graphqlTypes";
import { changeEventTypeToNameMapper } from "src/utils";
import { ChangeEventTypeBoundSelectField_ProjectFragment } from "./ChangeEventTypeBoundSelectField.generated";
import { defaultChangeEventTypeByLotType } from "./utils";

type ChangeEventTypeBoundSelectFieldProps = Pick<
  BoundSelectFieldProps<ChangeEventType, string>,
  "disabled" | "disabledOptions"
> & { field: FieldState<any>; project: ChangeEventTypeBoundSelectField_ProjectFragment };

export function ChangeEventTypeBoundSelectField({
  project,
  field,
  disabled,
  disabledOptions,
}: ChangeEventTypeBoundSelectFieldProps) {
  // Set the default value to the lot type's default change event type upon mount
  useEffect(() => {
    if (!field.value) {
      const defaultValue = defaultChangeEventTypeByLotType(
        { lotType: project.lotType.code, shouldAccrueAsComplete: project.shouldAccrueAsComplete },
        disabledOptions,
      );
      if (defaultValue) field.set(defaultValue);
    }
  }, []);
  return (
    <BoundSelectField
      label="Change Event Type"
      field={field}
      options={Object.entries(ChangeEventType)}
      getOptionValue={([_, type]) => type}
      getOptionLabel={([_, type]) => `${project.lotType.clientNoun} ${changeEventTypeToNameMapper(type)}`}
      disabledOptions={[
        ...(project.shouldAccrueAsComplete
          ? [
              {
                value: ChangeEventType.External,
                reason: "This project has reached investor closeout. Changes cannot be made to the PropCo price.",
              },
            ]
          : []),
        ...(disabledOptions ?? []),
      ]}
      disabled={disabled}
    />
  );
}
